module.exports = __webpack_public_path__ + "media/images/childcare/nassima@2x-a530c83b2b5cb096c94758d50e3b631b.jpg";